import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { intlShape } from 'react-intl';
import { Spinner } from 'shared-components/decorators/spinner';
import Stars from 'shared-components/stars/Stars';

export const BookingSummaryListing = ({ listing, intl }) => {
  if (!listing) {
    return (
      <div className='content-container flex center'>
        <Spinner additionalStyle='gray large' />
      </div>
    );
  }
  const {
    title,
    neighborhood,
    state,
    space_review_stars,
    space_review_count,
    canonical_loc_data
  } = listing;

  const listingImageId = get(listing, 'images[0].external_id', '');
  const listingImageUrl = listingImageId
    ? `https://res.cloudinary.com/peerspace-inc/image/upload/q_80,c_crop,g_custom/w_100,h_100,c_fill/${listingImageId}`
    : '';
  const listingDisplayCity =
    get(canonical_loc_data, 'locality.long_name', '') ||
    get(canonical_loc_data, 'administrative_area_level_2.long_name', '');

  return (
    <div data-testing-id='booking-summary-listing'>
      <div className='flex space-info'>
        <div>
          <img
            className='listing-img'
            src={listingImageUrl}
            alt={intl.formatMessage({
              id: 'inbox_guest_update_booking.booking_summary.listing',
              defaultMessage: 'Listing'
            })}
          />
        </div>
        <div className='hyphenate margin-lg-left'>
          <h6
            className='no-top-margin margin-sm-bottom'
            data-testing-id='title'
          >
            {title}
          </h6>
          <div className='flex flex-start text-gray-600 margin-sm-bottom'>
            <div>
              <img
                className='icon margin-md-right'
                src='/web-2/assets/images/location-icon.svg?v=rb'
                alt={intl.formatMessage({
                  id: 'inbox_guest_update_booking.booking_summary.location_icon',
                  defaultMessage: 'Location Icon'
                })}
              />
            </div>
            <div data-testing-id='location'>{`${
              neighborhood ? neighborhood + ', ' : ''
            }${listingDisplayCity}, ${state}`}</div>
          </div>

          <Stars
            reviewStars={space_review_stars}
            reviewCount={space_review_count}
            starClassName='yellow-star'
            reviewCountClassName='text-gray-dark'
          />
        </div>
      </div>
    </div>
  );
};

BookingSummaryListing.propTypes = {
  listing: PropTypes.object.isRequired,
  className: PropTypes.string,
  intl: intlShape
};
